/*
ファイルを選択すると直ちに送信する

<form action="./" method="post" autocomplete="off" enctype="multipart/form-data" class="js-fileSend-frame">
      <input type="file" class="js-fileSend" accept=".csv">

  <button type="submit" class="js-fileSend-submit"></button>
</form>
*/
if (document.getElementsByClassName('js-fileSend')[0]) {
  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-fileSend')
    if (!item) {
      return
    }
    const frame = item.closest('.js-fileSend-frame')

    const submit = frame.querySelector('.js-fileSend-submit')
    submit.click()
  })
}
